// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tx-0";